module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9065f"))).then(() => parcelRequire('d0iPb'));